<template>
  <Collaborators
    :scope-type="scopeType"
    :scope-id="scopeId"
  />
</template>

<script>
import Collaborators from './components/Collaborators'

export default {
  name: 'CollaboratorsIndex',
  components: { Collaborators },
  computed: {
    scopeType() {
      return this.$route.meta.scopeType || 'global'
    },
    scopeId() {
      if (this.scopeType === 'pica-service') {
        return this.$route.params.picaServiceId
      } else if (this.scopeType === 'contract-manager') {
        return this.$route.params.contractManagerId
      }
      return null
    }
  }
}
</script>